import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * ScrollTo class
 */
export default class ScrollTo extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'ScrollTo',
      log: isDev(),
    };
  }

  /**
   * Mounted
   */
  mounted() {
    const [url, targetId] = this.$el.href.split('#');
    if (
      url !== document.location.origin + document.location.pathname ||
      targetId === 'main-content' ||
      !targetId
    ) {
      return this.$destroy();
    }

    this.target = document.querySelector(`#${targetId}`) || null;
    if (!this.target) {
      return this.$destroy();
    }
    return true;
  }

  /**
   * On click
   *
   * @param {MouseEvent} e The event's object.
   */
  onClick(e) {
    e.preventDefault();
    this.target.scrollIntoView({ top: 0, behavior: 'smooth' });
  }
}
